<template>
  <div class="header">
    <div class="header_left">
      <Time></Time>
      <Weather></Weather>
    </div>
    <div class="header_right">
      <IndexBtn :type='type'></IndexBtn>
    </div>
  </div>
</template>

<script>
import Time from './Time.vue';
import Weather from './Weather.vue';
import IndexBtn from './IndexBtn.vue';

export default {
  components: { Time, Weather, IndexBtn },
  props: {
      type: {
          type:String,
          default: ''
      }
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
    height: 10%;
    background: url('../assets/image/pic/header_title.png') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    .header_left {
      width: 50%;
      text-align: center;
      display: flex;
      justify-content: center;
    }
    .header_right {
      width: 50%;
    }
}
</style>